<template>
  <div
    class="modal"
    :class="{ 'is-active': value }">

    <div class="modal-background"
      @click="close()">
    </div>
    
    <div class="modal-content">
      <div class="modal-card">

        <header class="modal-card-head">
          <p class="modal-card-title">Manage Warehouses</p>
          <button
            class="delete"
            aria-label="close"
            @click="close(true)">
          </button>
        </header>

        <div class="modal-card-body has-text-centered">

          <table class="table is-fullwidth">
            <thead>
              <tr>
                <th 
                  v-for="(header, headerIndex) in headers"
                  :key="headerIndex">
                  {{ header.label }}
                </th>
                <th></th>
              </tr>
            </thead>

            <tbody>
              <tr 
                class="v-centered"
                v-for="warehouse in warehouses"
                :key="warehouse.id">
                <td 
                  v-for="(header, headerIndex) in headers"
                  :key="headerIndex">
                  <span v-if="warehouse.id != editingId">
                    {{ warehouse[header.field] }}
                  </span>
                  <component  
                    v-else 
                    :is="header.component"
                    v-bind="header.bind"
                    v-model="warehouse[header.field]"/>
                </td>
                <td>
                  <div class="buttons buttons-right">
                    <template v-if="warehouse.id != editingId">
                      <button 
                        @click="editingId = warehouse.id"
                        class="button is-small">
                        <span class="icon has-text-grey">
                          <i class="fas fa-edit"></i>
                        </span>
                      </button>
                      <button 
                        @click="launchConfirmDelete(warehouse.id)"
                        class="button is-small">
                        <span class="icon has-text-grey">
                          <i class="fas fa-trash"></i>
                        </span>
                      </button>
                    </template>
                    <template v-else>
                      <button 
                        @click="update(warehouse)"
                        class="button is-small is-primary">
                        <span class="icon">
                          <i class="fas fa-save"></i>
                        </span>
                      </button>
                      <button 
                        @click="editingId = null"
                        class="button is-small">
                        <span class="icon has-text-grey">
                          <i class="fas fa-times"></i>
                        </span>
                      </button>
                    </template>
                  </div>
                </td>
              </tr>
              <tr class="v-centered" v-if="adding">
                <td 
                  v-for="(header, headerIndex) in headers"
                  :key="headerIndex">
                  <component 
                    :is="header.component" 
                    v-bind="header.bind"
                    v-model="warehouse[header.field]"/>
                </td>
                <td>
                  <div class="buttons buttons-right">
                    <button 
                      @click="addNew(warehouse)"
                      class="button is-small is-primary">
                      <span class="icon">
                        <i class="fas fa-save"></i>
                      </span>
                    </button>
                    <button 
                      @click="adding = false"
                      class="button is-small">
                      <span class="icon has-text-grey">
                        <i class="fas fa-times"></i>
                      </span>
                    </button>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>

          <button 
            v-if="!adding"
            class="button is-primary is-small" 
            @click="adding = true; editingId = null">
            Add a Warehouse
          </button>

        </div>

      </div>

      <v-confirm-modal 
        v-model="confirmDelete.state"
        :title="confirmDelete.title"
        :message="confirmDelete.message"
        :type="confirmDelete.type"
        @confirm="deleteConfirmedCb()"
        @cancel="deleteId = null; confirmDelete.state = false"/>

    </div>

  </div>
</template>

<script>
import VTextField from '@/components/base/VTextField'
import VConfirmModal from '@/components/base/VConfirmModal'

import { mapState, mapActions } from 'vuex'

export default {
  props: {
    value: {
      type: Boolean
    },
    warehouseId: {
      type: [String, Number]
    }
  },
  components: { 
    VTextField, 
    VConfirmModal
  },
  data() {
    return {
      headers: [
        { 
          label: 'Name', 
          field: 'warehouse_name', 
          component: 'VTextField', 
          bind: { required: true, placeholder: 'Warehouse Name' } 
        },
        { 
          label: 'Description', 
          field: 'warehouse_desc', 
          component: 'VTextField', 
          bind: { placeholder: 'Warehouse Description' } 
        },
        { 
          label: 'Warehouse Code', 
          field: 'warehouse_code', 
          component: 'VTextField', 
          bind: { required: true, placeholder: 'Warehouse Code' } 
        }
      ],
      warehouse: {
        warehouse_name: null,
        warehouse_desc: null,
        warehouse_code: null
      },
      editingId: null,
      adding: false,
      confirmDelete: {
        state: false,
        title: 'Delete Confirmation',
        message: 'Are you sure you want to delete this warehouse?',
        type: 'danger'
      },
      deleteConfirmedCb: null
    }
  },
  computed: {
    ...mapState("warehouses", ["warehouses"])
  },
  created() {
    this.initialize();
  },
  methods: {
    ...mapActions("warehouses", [
      "getWarehouses", "addWarehouse", "updateWarehouse", "deleteWarehouse"
    ]),
    initialize() {
      if (this.warehouses.length == 0) {
        this.getWarehouses();
      }
    },
    addNew() {
      this.addWarehouse({ 
        data: this.warehouse
      });
    },
    update(warehouse) {
      this.updateWarehouse({
        warehouseId: warehouse.id,
        data: {
          warehouse_name: warehouse.warehouse_name,
          warehouse_desc: warehouse.warehouse_desc,
          warehouse_code: warehouse.warehouse_code
        }
      }).then(() => this.editingId = null);
    },
    launchConfirmDelete(id) {
      this.deleteConfirmedCb = () => {
        this.deleteWarehouse(id);
        this.confirmDelete.state = false;
      }
      this.confirmDelete.state = true;
    },  
    close(clear=false) {
      this.$emit('input', false);
      if (clear) {
        this.clearData();
      }
    },
    clearData() {
      Object.assign(this.$data, this.$options.data.call(this));
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/styles/table.scss';

.modal-card {
  border-radius: 6px;
}
</style>
